import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { VhAlgorithm, VhQueryAutoWeb } from 'vhautowebdb';
import { FunctionService, LanguageService  } from 'vhobjects-service';
// import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'app-add-sub-menu-header-admin',
  templateUrl: './add-sub-menu-header-admin.component.html',
  styleUrls: ['./add-sub-menu-header-admin.component.scss']
})

export class AddSubMenuHeaderAdminComponent implements OnInit {
  @Input() data: any; // dữ liệu menu từ component cha truyền vào
  @Input() isAutoTranslate;
  @Output() isCancelFormAddSub = new EventEmitter(); // phát tính hiệu cancel cho component cha
  @Output() valueDataAdd = new EventEmitter(); // phát tính hiệu khi lưu cho component cha
  @Output() getDataCategoryAgain = new EventEmitter();

  // Mảng danh sách type (none/link-page/website/link-url/category)
  listLink = [
    {
      url: 'none',
      name: 'khong'
    },
    {
      url: 'link-page',
      name: 'den_trang_trong_website'
    },
    {
      url: 'website',
      name: 'lien_ket_website_khac'
    }
  ];
  
  listPageCategory: any = []; // biến chứa dữ liệu các Trang danh mục (category)
  listPageCategorySelected = new FormControl([]); // biến này chứa các danh mục được add
  isValid = true; // Biến này xác định form đã valid hay chưa (true: valid; false: chưa)

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhAlgorithm: VhAlgorithm,
    public functionService: FunctionService,
    private languageService: LanguageService,
  ) {
  }

  ngOnInit(): void {
    // Lấy dữ liệu
    this.getCategorySteps();
    this.checkEditCateSelected();
    this.onChangeAttr()
  }

  

  /**
   * Kiểm tra danh mục được chọn
   */
  checkEditCateSelected() {
    if(this.data.item.subData){
      this.data.item?.subData.forEach((data) => {
        if(data.listPageCategorySelected) {
          this.data.childMenu.listPageCategorySelected = data.listPageCategorySelected;
        }
      })
    }
  }

  /**
   * Lấy danh sách các Trang danh mục (category)
   */
  getCategorySteps() {
    this.vhQueryAutoWeb.getCategorySteps_byIdFatherCategory("", {}, {})
      .then((response: any) => {
        if (response.vcode === 0) {
          this.listPageCategory = response.data;
        }
      }, (error: any) => {
        
      })
  }

  /**
   * Bắt sự kiện thay đổi loại link (type)
   */
  changeType(){
    // reset các trường
    this.data.childMenu.id_page_category = null;
    // this.data.menu.id_freeblock = null;
    this.data.childMenu.link_page = null;
    this.data.childMenu.link_website = null; 
    this.onChangeAttr();
  }

  /**
   * Bắt sự kiện thay đổi các trường trong from khi thêm menu con cho groupParent là link
   */
  onChangeAttr() {
    const menu = this.data.childMenu;

    setTimeout(() => {
      if (!menu) return;

      const isValidBody =
          (menu.type === 'none') ||
          (menu.type === 'link-page') ||
          (menu.type === 'website' && menu.link_website) 
       

      const isValidLink = (menu.groupParent != 'category' && isValidBody);
      const checkLangMissingShort = this.functionService.multi_languages.some(lang => !menu[`name_${lang.code}`]?.trim());
      
      this.isValid = !checkLangMissingShort && isValidLink;
    }, 50)
  }

  /**
   * Bắt sự kiện thay đổi danh mục khi thêm menu con cho groupParent là category
   */
  onChange(value: any) {
    if(value.length > 0) this.isValid = true;
    else this.isValid = false;
  }

  /**
   * Lưu giá trị form thêm menu con và truyền về đi giao diện hiển thị
   */
  saveValueDataAdd() {
    // Xóa các trường không cần
    const menu = this.data.childMenu;
    // Xóa theo type
    const typeFieldsToDeleteMap = {
      'none': ['link_page', 'link_website'],
      'link-page': ['link_website'],
      'website': ['link_page', 'click_action', 'scroll_block_id'],
    };
    // Xóa theo group
    const groupFieldsToDeleteMap = {
      'link': ['id_page_category', 'id_freeblock'],
      'category': ['id_freeblock'],
      'pop-up': ['id_page_category']
    };
    // Mảng chứa các trường cần xóa
    const fieldsToDelete = typeFieldsToDeleteMap[menu.type] || [];
    fieldsToDelete.push(...groupFieldsToDeleteMap[menu.group] || []);
    // Xóa
    this.deleteFields(menu, fieldsToDelete);

    if (this.data.item.group === "category" || this.data.item.group === "pop-up-subcategory") {
      this.data.subData = [];
      if(this.data.item.subData) {
        this.data.item.subData.forEach((data) => {
          if(data.listPageCategorySelected) {
            this.data.subData.push(data);
          }
        })
      }
    }
    else {
      this.data.childMenu = {
        ...this.data.childMenu,
        level: this.data.item.level+1,
        _id :  this.vhAlgorithm.ObjectId(),
        children: []
      }
    }

    if (this.data.childMenu.type === 'link-page' && this.data.childMenu.link_page === undefined) this.data.childMenu.link_page = '';
    let link = this.data.childMenu.link_page;
    link = link ? '/' + link.replace(/^\/+/, '').replace(/\/+$/, '') : '';
    this.data.childMenu.link_page = link === '/' ? '' : link;


    // Gửi dữ liệu đi
    this.valueDataAdd.emit(this.data);
    this.isCancelFormAddSub.emit(false);
    this.getDataCategoryAgain.emit(true);
  }
  
  /**
   * Xóa các trường trong object
   * @param {Object} data - Object có trường cần xóa
   * @param {Array} fieldsToDelete - Mảng chứa tên các trường cần xóa
   */
  deleteFields(data, fieldsToDelete) {
    fieldsToDelete.forEach(field => {
      delete data[field];
    });
  }
  
  /**
   * Đóng form thêm menu con
   */
  cancleFormAddSub() {
    this.isCancelFormAddSub.emit(false);
  }
  
  autoTranslateNameLang() {    
    if (this.isAutoTranslate && this.data.childMenu['name_' + this.functionService.languageTempCode]) {
      this.functionService.showLoading(
        this.languageService.translate('dang_dich_cac_ngon_ngu_con_lai_cho_ten_menu_con'),
        "current-loading", null, 0, false
      ).then(() => {
        this.functionService.translateToMultipleLanguages(
          this.data.childMenu['name_' + this.functionService.languageTempCode],
          { isAdmin: true }
        )
        .subscribe({
          next: (data) => {
            // console.log('data', data)
            this.functionService.multi_languages.forEach(lang => {
              if (this.functionService.languageTempCode != lang.code) {
                this.data.childMenu['name_' + lang.code] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            });
            this.onChangeAttr(); // Cập nhật lại để nút "Thêm" hủy disabled
            this.functionService.hideLoading(300);
          },
          error: (err) => {
            console.error('Lỗi dịch thuật:', err);
            this.functionService.hideLoading(300);
          }
        });
      });
    }
  }
}
